import React from 'react';
import { Tabs, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { bubbleSetApi } from 'apis/platform/bubbleSetApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import DoubleTable from './DoubleTable';
import EmoticonTable from './EmoticonTable';
import NormalTable from './NormalTable';
import ReverseTable from './ReverseTable';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 세트 - 상세 페이지
 */

const BubbleSetTabsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  /// 탭을 클릭 했을 때
  const handleTabClick = (activeKey) => {
    navigate(`/bubble/${params.id}/${activeKey}`, {
      state: { tabKey: activeKey },
    });
  };

  return (
    <DefaultLayout>
      <Tabs
        style={{ margin: '0 20px 0 20px' }}
        // activeKey={location.state && location.state.tabKey ? location.state.tabKey : 'normal'}
        onChange={handleTabClick}
      >
        <Tabs.TabPane tab={t('bubbleID.tabPane.normal')} key='normal'>
          <NormalTable id={params.id} />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('bubbleID.tabPane.emoticon')} key='emoticon'>
          <EmoticonTable id={params.id} />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={t('bubbleID.tabPane.reversedEmoticon')}
          key='reemoticon'
        >
          <ReverseTable id={params.id} />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={t('bubbleID.tabPane.twoPersonStanding')}
          key='double'
        >
          <DoubleTable id={params.id} />
        </Tabs.TabPane>
      </Tabs>
    </DefaultLayout>
  );
};

export default BubbleSetTabsPage;
